// extracted by mini-css-extract-plugin
export default {"suggestedImprovementContainer":"SuggestedImprovement_suggestedImprovementContainer__n6Imn","likeAnimation":"SuggestedImprovement_likeAnimation__nfeXH"};